import { IDataDefinition } from "../../../Common/Data/Definitions/IDataDefinition";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ExpressionRule } from "../../ExpressionRule";

export abstract class BaseStringExpression extends ExpressionRule {
    protected _expressionValueType: IDataDefinition = new StringDataDefinition();

    get expressionValueType(): IDataDefinition {
        return this._expressionValueType;
    }

    set expressionValueType(expressionValueType: IDataDefinition) {
        this._expressionValueType = expressionValueType;
    }
}
